export default __webpack_public_path__ + "static/media/money-growth.8a950037.png";